import React, { useState, useEffect, useCallback } from "react";
import { useApi } from "../../hooks/useApi";
import { requestsAPI } from "../../services/api";
import EventInfoSection from "./EventInfoSection";
import OrganizerInfoSection from "./OrganizerInfoSection";
import DetailsTabs from "./DetailsTabs/DetailsTabs";
import Button from "../UI/Button";
import "./EventDetails.css";

const EventDetails = ({ eventId, isDetailsByEventId, onBack }) => {
  const [eventData, setEventData] = useState(null);
  const { loading, error, callApi } = useApi();

  const loadEventDetails = useCallback(async () => {
    try {
      const apiMethod = isDetailsByEventId
        ? requestsAPI.getRequestDetails
        : requestsAPI.getDetailsByFundRequestId;

      const data = await callApi(apiMethod, eventId);
      setEventData(data);
    } catch (err) {
      console.error("Failed to load event details:", err);
    }
  }, [eventId, isDetailsByEventId, callApi]);

  useEffect(() => {
    loadEventDetails();
  }, [loadEventDetails]);

  if (loading) {
    return (
      <div className="event-details__loading">
        <div className="loading-spinner">Loading event details...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="event-details__error">
        <p>Error loading event details: {error}</p>
        <Button onClick={onBack}>Back to Table</Button>
      </div>
    );
  }

  if (!eventData) {
    return null;
  }

  return (
    <div className="event-details">
      <div className="event-details__header">
        <Button
          variant="outline"
          onClick={onBack}
          className="event-details__back-btn"
        >
          ← Back to Requests
        </Button>
        <h1>Event #{eventData.event.id} Details</h1>
      </div>

      <div className="event-details__sections">
        <EventInfoSection event={eventData.event} />
        <OrganizerInfoSection organizer={eventData.organizer} />
      </div>

      <div className="event-details__tabs">
        <DetailsTabs data={eventData} />
      </div>
    </div>
  );
};

export default EventDetails;
